import { OptionsControl } from './options.model';
import { TemplateRef } from '@angular/core';
import {
  BaseControl,
  TransformText
} from '@app/shared/dynamic-form/shared/controls/base-control';


interface OptionsTinyEditor extends OptionsControl<string> {
  notResize: boolean;
  rows: string;
  cols: string;
  template: TemplateRef<any>;
  usar_editor ?: boolean;
  transform: TransformText;
}

export class TinyEditor extends BaseControl<string> implements OptionsTinyEditor {
  controlType = 'textarea';
  notResize: boolean;
  rows: string;
  cols: string;
  template: TemplateRef<any>;
  usar_editor ?: boolean;
  transform: TransformText;

  constructor(options: Partial<OptionsTinyEditor>) {
    super(options);
    this.notResize = options.notResize || false;
    this.rows = options.rows || '';
    this.cols = options.cols || '';
    this.template = options.template || null;
    this.usar_editor = options.usar_editor;
    this.transform = options.transform;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/dynamic-form/shared/controls/tinyeditor.ts